<template>
  <section class="vbox">    
    <section class="scrollable wrapper">
      <div class="content-header">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item><a href="/">会员</a></el-breadcrumb-item>
          <el-breadcrumb-item>储值卡</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <el-form ref="form" v-model="merchantCard" label-width="160px" size="medium">
        <el-form-item label="名称">
          <el-col :span="11">
            <el-input v-model="merchantCard.name" ></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="所属商家">
          <el-col :span="11">
            <el-input v-model="merchantName" readonly placeholder="名称">
              <el-button  slot="append" icon="el-icon-search" @click="selectMerchantHandle"></el-button>
            </el-input>   
          </el-col>
        </el-form-item> 
        <el-form-item label="价格">
          <el-col :span="11">
            <el-input v-model="merchantCard.price"  :min="1" :max="1000000" label="描述文字">
              <el-button slot="append" >元</el-button>
            </el-input>
          </el-col>
        </el-form-item>        
        <el-form-item label="储值">
          <el-col :span="11">
            <el-input v-model="merchantCard.value"  :min="1" :max="1000000" label="描述文字">
              <el-button slot="append" >元</el-button>
            </el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="推荐消费奖励">
          <el-col :span="11">
            <el-input v-model="merchantCard.recommendConsumeReward" >
              <el-button slot="append" >%</el-button>
            </el-input>
          </el-col>          
        </el-form-item>
        <el-form-item label="分享描述">
          <el-col :span="11">
            <el-input type="textarea" v-model="merchantCard.shareDescription"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="描述">
          <editor @showEditor="updateDescription" :content="merchantCard.description"></editor>
        </el-form-item>
        <el-form-item >
          <el-col :span="11">
            <el-button type="primary" @click="SaveBusinessCard">保 存</el-button>
            <el-button style="margin-left: 8px" @click="handleBack">返回列表</el-button>
          </el-col>
        </el-form-item>
      </el-form>
    </section>
    <GetMerchant v-bind:dialogMerchant="dialogMerchant" @UpdateMerchant="UpdateMerchant"></GetMerchant> 
  </section>
</template>
<script  type='text/ecmascript-6'>
  import editor from '@/components/wang-editor'  
  import GetMerchant from '@/components/GetMerchant'
  export default {
    props:{
    },
    data (){
      return {
        merchantCard:{},
        merchantName:'',    
        dialogMerchant:{
          isShow:false
        },
      }
    },
    computed:{
    },
    mounted(){
      var that = this
      this.axios({
        method:'get',
        url:that.global.serverSrc + '/api/MerchantCard/Get',         
        params:{
          id:that.$route.params.Id
        }
      }).then(function (resp) {
        that.merchantCard = resp.data.merchantCard,
        that.merchantName = resp.data.merchantName
      })
      
    },
    methods:{     
      SaveBusinessCard:function(){
        var that = this
        this.axios({
          method:'post',
          url:that.global.serverSrc + '/api/MerchantCard/Save',         
          data:that.merchantCard
        }).then(function (resp) {
          if(resp.data.errorCode==0){
            that.$message.success(resp.data.message);
          }else {
            that.$message.warning(resp.data.message);
          }  
        }).catch(resp => {         
          console.log('请求失败：' + resp.message + ',' + resp.stack)
        })
      },
      updateDescription(data){
        this.merchantCard.description=data
      },
      selectMerchantHandle:function(){
        this.dialogMerchant.isShow = true
      },
      UpdateMerchant(id,name){
        this.merchantName = name
        this.merchantCard.merchantId = id
      },      
      handleBack(){
        var that = this
        this.$confirm('请先确定已经保存内容！', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          that.$router.push({
            name: 'businessCard',
            params: {
              queryParam: that.$route.params.queryParam
            }
          })
        }).catch(() => {
            
        });
      }
    },
    components:{    
      editor,
      GetMerchant
    },
    created(){
    
    },
  }
</script>
<style lang='stylus' rel='stylesheet/stylus'>
  .content-header
    padding 24px
    border 1px solid #C0C4CC
    margin-bottom 24px 
</style>